// 删除URL中的参数，但不刷新当前页面。
// 如果用户下次刷新页面，被删除的参数不会出现。
export const removeSearchParam = (key: string) => {
  const searchParams = new URLSearchParams(window.location.search);
  searchParams.delete(key);
  const newURL = `${window.location.origin}${window.location.pathname}?${searchParams.toString()}`;

  window.history.pushState(null, document.title, newURL);
};
